import { useEffect, useState } from "react";

/**
 * Debounces a value by `delayMs`. Returns the most-recent input that has
 * remained stable for the full delay window.
 *
 * Used for the search inputs on `/policies` and `/insureds` (CSR-674) so
 * we update the URL (and hit the server) at most every 250 ms instead of
 * on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
